import storage from 'redux-persist/lib/storage';

export type PersistConfig = {
  key: string;
  storage: Storage;
  blacklist?: string[]; // do not persist these keys
  whitelist?: string[]; // only persist these keys
};

export const basePersistConfig: PersistConfig = {
  key: 'root',
  storage,
  blacklist: ['fabric'],
};
